var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14362 5.11004L1.14363 5.11003L4.91521 1.15423C5.17483 0.881931 5.59679 0.881917 5.85632 1.15423L1.14362 5.11004ZM1.14362 5.11004C1.01439 5.24564 0.95 5.42311 0.95 5.59998C0.95 5.77677 1.01424 5.95424 1.1435 6.08993L1.14351 6.08994L4.91509 10.0457C4.91509 10.0457 4.9151 10.0457 4.9151 10.0457C5.17472 10.3181 5.59669 10.3181 5.85622 10.0457C6.11445 9.77482 6.11443 9.3366 5.85621 9.06565L5.8562 9.06565L2.55191 5.59998L5.85632 2.13434L5.85633 2.13433M1.14362 5.11004L5.85633 2.13433M5.85633 2.13433C6.11455 1.86337 6.11456 1.42509 5.85633 1.15424L5.85633 2.13433Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e76e2f92ea0f44737ca03573c5bca095.svg";
export { ForwardRef as ReactComponent };